var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0991211 28.5L17.5408 0L34.9825 28.5H0.0991211ZM5.56947 25.5H29.5121L17.5408 6L5.56947 25.5ZM17.5408 24C17.9901 24 18.3666 23.8563 18.6706 23.5688C18.9745 23.2812 19.1264 22.925 19.1264 22.5C19.1264 22.075 18.9745 21.7188 18.6706 21.4313C18.3666 21.1438 17.9901 21 17.5408 21C17.0916 21 16.715 21.1438 16.4111 21.4313C16.1072 21.7188 15.9552 22.075 15.9552 22.5C15.9552 22.925 16.1072 23.2812 16.4111 23.5688C16.715 23.8563 17.0916 24 17.5408 24ZM15.9552 19.5H19.1264V12H15.9552V19.5Z",
    fill: "#DC5126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.873c9975ece7e18b87e2fe9b44bcf658.svg";
export { ForwardRef as ReactComponent };